var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.42,
    height: 34.833,
    viewBox: "0 0 31.42 34.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "lamp (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59553",
    d: "M8.377 31.833c6.917 0 11.667 3.583 15 3.583S33.71 33.5 33.71 18.167 24.293.583 20.627.583c-17.167 0-24.5 31.25-12.25 31.25z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18489"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59558",
    d: "m24.571 11.429 1.383-1.383z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59559",
    d: "M27.293 18z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59560",
    d: "m24.571 24.571 1.383 1.383z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59561",
    d: "m11.429 24.571-1.383 1.383z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59562",
    d: "M8.707 18z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59563",
    d: "m11.429 11.429-1.383-1.383z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59564",
    d: "M18.25 14.25a3.5 3.5 0 0 1 3.5 3.5z",
    style: {
      fill: "#2fdf84"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59565",
    d: "M24.25 18a6.252 6.252 0 1 0-10.008 4.987 3.988 3.988 0 0 1 1.508 3.2v1.764c0 .853.448 1.294 1 1.294h2.5a1 1 0 0 0 1-1v-2.218a4 4 0 0 1 1.612-3.119A6.229 6.229 0 0 0 24.25 18z",
    style: {
      fill: "#ffef95"
    },
    transform: "translate(-2.29 -.583)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59566",
    d: "M17.75 27.956v-1.764a3.988 3.988 0 0 0-1.508-3.2 6.246 6.246 0 0 1 2.409-11.1c.119-.025.237-.035.355-.054a6.4 6.4 0 0 0-2.355.054 6.246 6.246 0 0 0-2.409 11.1 3.988 3.988 0 0 1 1.508 3.2v1.764c0 .853.448 1.294 1 1.294h2c-.552 0-1-.441-1-1.294z",
    style: {
      fill: "#f7de5c"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59567",
    d: "M19.41 29.25h-2.82a.84.84 0 0 1-.84-.84v-2.16h4.5v2.16a.84.84 0 0 1-.84.84z",
    style: {
      fill: "#f3f3f1"
    },
    transform: "translate(-2.29 -.583)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59568",
    d: "M17.75 28.41v-2.16h-2v2.16a.84.84 0 0 0 .84.84h2a.84.84 0 0 1-.84-.84z",
    style: {
      fill: "#d5dbe1"
    },
    transform: "translate(-2.29 -.583)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59569",
    d: "M13.46 24.917h4.5v1.5h-4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59570",
    d: "M14.96 5.417h1.5v3.457h-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59571",
    d: "m21.22 10.846 2.445-2.444 1.06 1.06-2.444 2.445z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59572",
    d: "M24.253 16.667h3.457v1.5h-3.457z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59573",
    d: "m21.221 23.988 1.06-1.06 2.445 2.444-1.06 1.06z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59574",
    d: "m6.694 25.373 2.444-2.445 1.061 1.06-2.444 2.445z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59575",
    d: "M3.71 16.667h3.457v1.5H3.71z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59576",
    d: "m6.694 9.462 1.061-1.06 2.445 2.444-1.061 1.06z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59577",
    d: "M20.21 17.167h-1.5a2.752 2.752 0 0 0-2.75-2.75v-1.5a4.255 4.255 0 0 1 4.25 4.25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59578",
    d: "M16.96 29.417h-2.5a1.823 1.823 0 0 1-1.75-2.044v-1.764a3.242 3.242 0 0 0-1.209-2.6 7 7 0 1 1 9.162-10.535l-1.062 1.061a5.5 5.5 0 1 0-7.2 8.276 4.748 4.748 0 0 1 1.807 3.8v1.764c0 .091.012.544.25.544h2.5a.25.25 0 0 0 .25-.25v-2.224a4.748 4.748 0 0 1 1.9-3.709 5.5 5.5 0 0 0 1.687-6.42l1.386-.573a7 7 0 0 1-2.146 8.174 3.258 3.258 0 0 0-1.325 2.527v2.223a1.752 1.752 0 0 1-1.75 1.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.dbd1133cd769ade6eee2cabc32501ecb.svg";
export { ForwardRef as ReactComponent };